import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import Pagination from "../../../../Helper/Pagination";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";
import defaultImg from "../../../../assets/img/thumbnail.png";
import { format } from "date-fns";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";

export default function Order() {
  const [orderlist, setorderlist] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState({
    status: "",
    orderId: "",
    filter: "",
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [loading, setLoading] = useState(true);
  const [Downloadloading, setDownloadLoading] = useState(false);
  const [selectedState, setselectedState] = useState("");
  const [OrderImage, setOrderImage] = useState(false);
  const [modalShow, setmodalShow] = useState(false);
  const [viewItemDetails, setviewItemDetails] = useState("");
  const [Min_delivery_day, setMin_delivery_day] = useState("");
  const [Max_delivery_day, setMax_delivery_day] = useState("");
  const [DeliveryList, setDeliveryList] = useState("");
  const [deliveryId, setdeliveryId] = useState("");
  const [orderMessage, setorderMessage] = useState("");
  const [orderstatus, setorderstatus] = useState("");
  const [error, setError] = useState(false);

  const message = {
    "Creating Order": "Your order has been accepted successfully.",
    Shipping: `Your order has been shipped and is expected to be delivered in ${Min_delivery_day}-${Max_delivery_day} days.`,
    "Out For Delivery": `Your order is out for delivery and is expected to be delivered in ${Min_delivery_day}-${Max_delivery_day} days.`,
    Delivered: "Your order has been delivered.",
    "Cancel Order": `${orderMessage}`,
  };
  const getOrderList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      filter: search_key?.filter,
      status: search_key?.status,
      orderId: search_key?.orderId,
    };

    PostService(API_URL.GET_ORDER_LIST, param).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setorderlist(res?.data?.data);
        SetTotalPageCount(res?.data?.totalPages);
        SetTotalCount(res?.data?.totalItems);
        setCount(res?.data?.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  const getDeliveryList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_DELIVERY_LIST, param).then((res) => {
      console.log(res?.data?.status);
      if (res?.data?.status === true) {
        setDeliveryList(res?.data?.data?.item);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };
  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };
  function getOrderImageDownload(itemImages) {
    setDownloadLoading(true);
    const data = [];
    if (itemImages) {
      const image = JSON.parse(itemImages);
      for (let i of image) {
        data.push(i);
      }
      PostService(API_URL.GET_IMAGE, {
        images: data,
        order_no: selectedState?.order_no,
      }).then((res) => {
        setDownloadLoading(false);
        if (res?.data?.status) {
          res?.data?.data.forEach((image, index) => {
            handleDownload(image, `Image ${index}_${selectedState?.order_no}`);
          });
        }
      });
    }
  }
  const handleDownload = (url, fileName) => {
    console.log(url);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    getOrderList();
  }, [search_key, currentPage]);

  useEffect(() => {
    getDeliveryList();
  }, []);

  const changeStatus = async (item, status) => {
    const data = {
      orderId: item?.id,
      status: status,
      orderMessage: message[status],
      deliveryId: deliveryId ? deliveryId : null,
      phoneNumber: item?.bphone ? item?.bphone : null,
      order_no: item?.order_no ? item?.order_no : null,
      changed_by: "admin",
    };

    PostService(API_URL.CHANGE_ORDER_STATUS, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getOrderList);
          setmodalShow(false);
          setMin_delivery_day("");
          setMax_delivery_day("");
          setorderstatus("");
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Orders List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Orders List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        <div class="card-body">
          <div className="d-flex justify-content-end mb-4">
            <div className="col-md-2">
              <label className="font-weight-bold text-small">Duration</label>
              <select
                className="form-control"
                onChange={(e) => {
                  setsearch_key({
                    filter: e.target.value,
                  });
                  setCurrentPage(0);
                }}
              >
                <option value="">All</option>
                <option value="day">Today</option>
                <option value="week">Week</option>
                <option value="month">Month</option>
                <option value="year">Year</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="font-weight-bold text-small">Status</label>
              <select
                className="form-control"
                onChange={(e) => {
                  setsearch_key({
                    status: e.target.value,
                  });
                  setCurrentPage(0);
                }}
              >
                <option value="">All</option>
                <option value="Order Placed">Order Placed</option>
                <option value="Creating Order">Creating Order</option>
                <option value="Shipping">Shipping</option>
                <option value="Out For Delivery">Out For Delivery</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancel Order">Cancel Order</option>
              </select>
            </div>
            <div className="col-md-4 p-0">
              <label className="font-weight-bold text-small">OrderId</label>
              <input
                type="text"
                name="firstnamesearch"
                placeholder="Search By OrderId"
                className="form-control"
                autoComplete="off"
                onChange={(e) => {
                  setTimeout(() => {
                    setsearch_key({
                      orderId: e.target.value,
                    });
                    setCurrentPage(0);
                  }, 400);
                }}
              />
            </div>
          </div>
          {/* <h4 class="card-title">Image Listing</h4> */}

          <div class="table-responsive mt-3">
            <table class="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Order No</th>
                  <th>Image</th>
                  <th>User Name</th>
                  <th>Items</th>
                  <th>Amount ($)</th>
                  <th>Address</th>
                  <th>Order Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {orderlist?.map((item, i) => (
                  <tr key={i}>
                    <td>{i + S_No_Count + 1}</td>
                    <td>{item?.order_no}</td>
                    <td>
                      <div
                        className="cursor position-relative"
                        onClick={() => {
                          console.log(item?.orderItems?.length === 1 ? 0 : "");
                          setviewItemDetails(
                            item?.orderItems?.length === 1 ? 0 : ""
                          );
                          setselectedState(item);
                          setOrderImage(true);
                        }}
                      >
                        {item?.orderItems?.length > 1 && (
                          <span
                            className="bg-primary p-1 position-absolute text-white text-small"
                            style={{ opacity: ".7" }}
                          >
                            +{item?.orderItems?.length - 1}
                          </span>
                        )}
                        <img
                          src={
                            item?.orderItems[0]?.MergedImage ||
                            item?.orderItems[0]?.gift_card_Details?.image
                          }
                          alt=""
                          onError={(e) => {
                            e.target.src = defaultImg;
                          }}
                        />
                      </div>
                    </td>
                    <td>{item?.registration?.fullName || "N/A"}</td>
                    <td>{item?.orderItems?.length}</td>
                    <td>{item?.total_amount}</td>
                    <td>
                      <p>{item?.baddress1}</p>
                      <p>
                        {item?.bcity ? (
                          <span className="font-weight-bold">
                            {item?.bcity},
                          </span>
                        ) : (
                          ""
                        )}{" "}
                        {item?.BState?.state_name ? (
                          <span className="font-weight-bold">
                            {item?.BState?.state_name},
                          </span>
                        ) : (
                          ""
                        )}{" "}
                        {item?.BCountry?.country_name ? (
                          <span className="font-weight-bold">
                            {item?.BCountry?.country_name}
                          </span>
                        ) : (
                          ""
                        )}
                      </p>
                    </td>
                    <td>
                      {item?.created_at
                        ? format(new Date(item?.created_at), "dd/MM/yyyy")
                        : "N/A"}
                    </td>
                    <td>
                      <Dropdown as={ButtonGroup}>
                        <Button
                          variant={
                            item?.order_status === "Order Placed"
                              ? "warning"
                              : item?.order_status === "Cancel Order"
                              ? "danger"
                              : "success"
                          }
                          className="py-2 px-2 bg_primary btn-sm"
                          disabled={item?.order_status === "Cancel Order"}
                        >
                          {item?.order_status}
                        </Button>

                        <Dropdown.Toggle
                          split
                          variant={
                            item?.order_status === "Order Placed"
                              ? "warning"
                              : item?.order_status === "Cancel Order"
                              ? "danger"
                              : "success"
                          }
                          id="dropdown-split-basic"
                          className="py-2 px-2 bg_primary btn-sm"
                          disabled={item?.order_status === "Cancel Order"}
                        />

                        <Dropdown.Menu>
                          <Dropdown.Item
                            className="mb-1 font-weight-bold"
                            onClick={() => changeStatus(item, "Creating Order")}
                          >
                            Creating Order
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="mb-1 font-weight-bold"
                            onClick={() => {
                              setorderstatus({
                                status: "Shipping",
                                id: item?.id,
                                bphone: item?.bphone,
                                order_no: item?.order_no,
                              });
                              !item?.delivery_id
                                ? setmodalShow(true)
                                : changeStatus(item, "Shipping");
                            }}
                          >
                            Shipping
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="mb-1 font-weight-bold"
                            onClick={() => {
                              setorderstatus({
                                status: "Out For Delivery",
                                id: item?.id,
                                bphone: item?.bphone,
                                order_no: item?.order_no,
                              });
                              setmodalShow(true);
                              setdeliveryId(item?.delivery_id);
                            }}
                          >
                            Out For Delivery
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="mb-1 font-weight-bold"
                            onClick={() => {
                              setorderstatus({
                                status: "Delivered",
                                id: item?.id,
                                bphone: item?.bphone,
                                order_no: item?.order_no,
                              });
                              !item?.delivery_id
                                ? setmodalShow(true)
                                : changeStatus(item, "Delivered");
                            }}
                          >
                            Delivered
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="mb-1 font-weight-bold"
                            onClick={() => {
                              setorderstatus({
                                status: "Cancel Order",
                                id: item?.id,
                                bphone: item?.bphone,
                                order_no: item?.order_no,
                              });
                              setmodalShow(true);
                            }}
                          >
                            Cancel Order
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                    <td>
                      <span
                        title="view"
                        style={{ cursor: "pointer" }}
                        className="mx-2"
                        data-toggle="modal"
                      >
                        <Link to={`view_order/${item?.id}`}>
                          <i className="text-warning fas fa-eye"></i>{" "}
                        </Link>
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
              {orderlist && orderlist?.length === 0 && (
                <tr>
                  <td colSpan="10" className="text-center">
                    <h6 className="p-3"> No Data Found </h6>
                  </td>
                </tr>
              )}
              <div
                className={`view_order_image rounded ${
                  OrderImage ? "active_order_image" : ""
                }`}
              >
                {selectedState && OrderImage && (
                  <>
                    <div className="d-flex justify-content-between mt-4 mx-4 text-white">
                      <h3>View Order Image</h3>
                      <i
                        className="fa-solid fa-xmark cursor fa-2x"
                        onClick={() => {
                          setOrderImage(false);
                          setviewItemDetails("");
                        }}
                      ></i>
                    </div>
                    <div className="mx-3 mt-5 d-flex flex-wrap ">
                      {selectedState &&
                        viewItemDetails === "" &&
                        selectedState?.orderItems?.map((res, i) => (
                          <div className="order_image" key={i}>
                            <div className="hover_image" title="view Details">
                              <img
                                src={
                                  res?.MergedImage
                                    ? res?.MergedImage
                                    : res?.gift_card_Details?.image
                                }
                                alt=""
                                height={"100%"}
                                onClick={() => setviewItemDetails(i)}
                                onError={(e) => {
                                  e.target.src = defaultImg;
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      {/* view per order */}
                    </div>
                    {selectedState &&
                      viewItemDetails >= 0 &&
                      selectedState?.orderItems[viewItemDetails] && (
                        <div className="mx-4">
                          {selectedState?.orderItems?.length !== 1 && (
                            <div className="mb-2">
                              <i
                                title="go back"
                                class="fa-solid fa-arrow-left text-white cursor"
                                onClick={() => setviewItemDetails("")}
                              ></i>
                            </div>
                          )}
                          <div className="d-flex mt-3 justify-content-between">
                            <div className="ml-4 d-flex">
                              <img
                                src={
                                  selectedState?.orderItems[viewItemDetails]
                                    ?.MergedImage ||
                                  selectedState?.orderItems[viewItemDetails]
                                    ?.gift_card_Details?.image
                                }
                                alt=""
                                height={"100%"}
                                onError={(e) => {
                                  e.target.src = defaultImg;
                                }}
                                style={{
                                  maxHeight: "250px",
                                  maxWidth: "450px",
                                }}
                              />

                              {!selectedState?.orderItems[viewItemDetails]
                                ?.gift_card_Details && (
                                <div className="d-flex justify-content-end text-white ml-5">
                                  <div>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{ letterSpacing: "2px" }}
                                    >
                                      Layout :
                                    </p>
                                    {(selectedState?.orderItems[viewItemDetails]
                                      ?.Layout === "single_panel" ||
                                      selectedState?.orderItems[viewItemDetails]
                                        ?.Layout === "Single Panel" ||
                                      selectedState?.orderItems[viewItemDetails]
                                        ?.Layout === "split_canvas" ||
                                      selectedState?.orderItems[viewItemDetails]
                                        ?.Layout === "Split Canvas") && (
                                      <p
                                        className="fa-1x font-weight-bold mb-3"
                                        style={{ letterSpacing: "2px" }}
                                      >
                                        Type :
                                      </p>
                                    )}
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{ letterSpacing: "2px" }}
                                    >
                                      Order size :
                                    </p>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{ letterSpacing: "2px" }}
                                    >
                                      Quantity :
                                    </p>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{ letterSpacing: "2px" }}
                                    >
                                      Layout Price :
                                    </p>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{ letterSpacing: "2px" }}
                                    >
                                      Edge :
                                    </p>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{ letterSpacing: "2px" }}
                                    >
                                      Effects :
                                    </p>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{ letterSpacing: "2px" }}
                                    >
                                      Retouching :
                                    </p>

                                    {selectedState?.orderSummery?.discount !==
                                      0 &&
                                      selectedState?.orderItems?.length ===
                                        1 && (
                                        <p
                                          className="fa-1x font-weight-bold mb-3"
                                          style={{ letterSpacing: "2px" }}
                                        >
                                          Discount :
                                        </p>
                                      )}
                                    <div className="mt-3">
                                      <button
                                        className="bg-white btn font-weight-bold py-2"
                                        onClick={() =>
                                          getOrderImageDownload(
                                            selectedState?.orderItems[
                                              viewItemDetails
                                            ]?.images
                                          )
                                        }
                                      >
                                        Download Image{" "}
                                        {Downloadloading ? (
                                          <Spinner
                                            animation="border"
                                            role="status"
                                            className="spinner ml-1"
                                          ></Spinner>
                                        ) : (
                                          <i class="fa-solid fa-download ml-1"></i>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                  <div className="ml-4">
                                    <p className="fa-1x mb-3">
                                      {selectedState?.orderItems[
                                        viewItemDetails
                                      ]?.Layout === "gallery_wall" ||
                                      selectedState?.orderItems[viewItemDetails]
                                        ?.Layout === "Gallery Wall"
                                        ? "Gallery Wall"
                                        : selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "story_canvas" ||
                                          selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "storyCanvas"
                                        ? "Story Canvas"
                                        : selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "split_canvas" ||
                                          selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "Split Canvas"
                                        ? "Split Canvas"
                                        : selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "single_panel" ||
                                          selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "Single Panel"
                                        ? "Single Canvas"
                                        : selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "plexi_print" ||
                                          selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "Plexi Print"
                                        ? "Plexi Print"
                                        : selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "art_tray" ||
                                          selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "Art Tray"
                                        ? "Art Tray"
                                        : selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "wood_print" ||
                                          selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "Wood Print"
                                        ? "Wood Print"
                                        : selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "diamond_dust" ||
                                          selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Layout === "Diamond Dust"
                                        ? "Diamond Dust"
                                        : "-"}
                                    </p>

                                    {(selectedState?.orderItems[viewItemDetails]
                                      ?.Layout === "single_panel" ||
                                      selectedState?.orderItems[viewItemDetails]
                                        ?.Layout === "Single Panel") && (
                                      <p className="fa-1x mb-3">
                                        {selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.type === "framed"
                                          ? "Framed"
                                          : selectedState?.orderItems[
                                              viewItemDetails
                                            ]?.type === "thinGallery"
                                          ? "Thin Gallery Wrap (0.75)"
                                          : selectedState?.orderItems[
                                              viewItemDetails
                                            ]?.type === "thickGallery"
                                          ? "Thick Gallery Wrap (1.5)"
                                          : selectedState?.orderItems[
                                              viewItemDetails
                                            ]?.type === "rolled"
                                          ? "Rolled in a Tube"
                                          : ""}
                                      </p>
                                    )}
                                    {(selectedState?.orderItems[viewItemDetails]
                                      ?.Layout === "split_canvas" ||
                                      selectedState?.orderItems[viewItemDetails]
                                        ?.Layout === "Split Canvas") && (
                                      <p className="fa-1x mb-3">
                                        {selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.size_detail?.panels === 2
                                          ? "DYPTYCHS"
                                          : "TRYPTYCHS"}{" "}
                                        -{" "}
                                        {selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.size_detail?.price
                                          ? "Standard 3/4"
                                          : "Thick 1 1/2"}
                                      </p>
                                    )}

                                    <p className="fa-1x mb-3">
                                      {
                                        selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.size_detail?.size
                                      }
                                    </p>
                                    <p className="fa-1x mb-3">
                                      {
                                        selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.quantity
                                      }
                                    </p>
                                    <p className="fa-1x mb-3">
                                      $ 
                                      {
                                        selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.size_detail?.thick_price ?
                                        selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.size_detail?.thick_price : 
                                        selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.size_detail?.price
                                      }
                                    </p>
                                    <p className="fa-1x mb-3">
                                      {selectedState?.orderItems[
                                        viewItemDetails
                                      ]?.Edge
                                        ? (() => {
                                            const data = JSON.parse(
                                              selectedState?.orderItems[
                                                viewItemDetails
                                              ]?.Edge
                                            );
                                            return `${
                                              data?.edge ? data?.edge : "None"
                                            } ${
                                              data?.price
                                                ? `($${data?.price})`
                                                : ""
                                            }`;
                                          })()
                                        : "-"}
                                    </p>
                                    <p className="fa-1x mb-3">
                                      {selectedState?.orderItems[
                                        viewItemDetails
                                      ]?.Services?.Effects?.name
                                        ? `${
                                            selectedState?.orderItems[
                                              viewItemDetails
                                            ]?.Services?.Effects?.name || "-"
                                          } ${
                                            selectedState?.orderItems[
                                              viewItemDetails
                                            ]?.Services?.Effects?.price
                                              ? `($${selectedState?.orderItems[viewItemDetails]?.Services?.Effects?.price})`
                                              : ""
                                          }`
                                        : "-"}
                                    </p>
                                    <p className="fa-1x mb-3">
                                      {selectedState?.orderItems[
                                        viewItemDetails
                                      ]?.Services?.Retouching?.name ? (
                                        <>
                                          {selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Services?.Retouching?.name || "-"}
                                          {selectedState?.orderItems[
                                            viewItemDetails
                                          ]?.Services?.Retouching?.price ? (
                                            <span>
                                              {" "}
                                              ($
                                              {
                                                selectedState?.orderItems[
                                                  viewItemDetails
                                                ]?.Services?.Retouching?.price
                                              }
                                              )
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      ) : (
                                        "-"
                                      )}
                                    </p>

                                    {selectedState?.orderSummery?.discount !==
                                      0 &&
                                      selectedState?.orderItems?.length ===1 && (
                                        <p className="fa-1x mb-3">
                                          <div className="mt-2">
                                            <span className="mr-2">
                                              ${" "}
                                              {
                                                selectedState?.orderSummery
                                                  ?.discount
                                              }
                                            </span>
                                            <span>
                                              (Promo Code (
                                              {selectedState?.promoCode}))
                                            </span>
                                          </div>
                                        </p>
                                      )}
                                  </div>
                                </div>
                              )}
                              {selectedState?.orderItems[viewItemDetails]
                                ?.gift_card_Details && (
                                <div className="d-flex justify-content-end text-white ml-5 d-none">
                                  <div>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{
                                        letterSpacing: "2px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Card Name :
                                    </p>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{
                                        letterSpacing: "2px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Card Price :
                                    </p>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{
                                        letterSpacing: "2px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Quantity :
                                    </p>
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{
                                        letterSpacing: "2px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Description :
                                    </p>
                                    {selectedState?.orderSummery?.discount !==
                                      0 &&
                                      selectedState?.orderItems?.length ===
                                        1 && (
                                        <p
                                          className="fa-1x font-weight-bold mb-3"
                                          style={{
                                            letterSpacing: "2px",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          Discount :
                                        </p>
                                      )}
                                  </div>
                                  <div className="ml-4">
                                    <p className="fa-1x mb-3">
                                      {
                                        selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.gift_card_Details?.name
                                      }
                                    </p>
                                    <p className="fa-1x mb-3">
                                      ${" "}
                                      {
                                        selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.gift_card_Details?.price
                                      }
                                    </p>
                                    <p className="fa-1x mb-3">
                                      {
                                        selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.quantity
                                      }
                                    </p>
                                    <p className="fa-1x mb-3 w-75">
                                      {
                                        selectedState?.orderItems[
                                          viewItemDetails
                                        ]?.gift_card_Details?.description
                                      }
                                    </p>

                                    {selectedState?.orderSummery?.discount !==
                                      0 &&
                                      selectedState?.orderItems?.length ===
                                        1 && (
                                        <p className="fa-1x mb-3">
                                          <div>
                                            Promo Code ({" "}
                                            {selectedState?.promoCode} )
                                          </div>
                                          <div className="mt-2">
                                            {" "}
                                            ($ -
                                            {
                                              selectedState?.orderSummery
                                                ?.discount
                                            }
                                            )
                                          </div>
                                        </p>
                                      )}
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="text-white ">
                              <h4 className="mb-4">Total Price</h4>
                              <p className="fa-2x">
                                $
                                {selectedState?.orderItems?.length === 1
                                  ? selectedState.orderSummery?.total
                                  : selectedState?.orderItems[viewItemDetails]
                                      ?.price}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                )}
              </div>
            </table>
            {loading ? (
              <div className="LoaderSpinner">
                <MoonLoader
                  color={"#003bff"}
                  loading={loading}
                  speedMultiplier={0.6}
                  size={50}
                />
                <div>Loading... Please wait.</div>
              </div>
            ) : (
              ""
            )}
            <div className="mt-4">
              <Pagination
                counting={S_No_Count}
                totaldata={TotalCount}
                pagecount={TotalPageCount}
                onChangePage={handlePageClick}
                activePage={currentPage}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={modalShow}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="d-flex justify-content-between">
          <Modal.Title id="contained-modal-title-vcenter w-100">
            <h4>
              {orderstatus === "Cancel Order"
                ? "Order cancellation Reason"
                : "Add Delivery Information"}
            </h4>
          </Modal.Title>
          <i class="fa-solid fa-xmark" onClick={() => setmodalShow(false)}></i>
        </Modal.Header>
        <Modal.Body>
          <div className="row mt-2">
            {orderstatus?.status !== "Cancel Order" && (
              <>
                <div className="col-12 mb-3">
                  <label>Select Delivery Partner</label>
                  <select
                    className="form-control"
                    onChange={(e) => setdeliveryId(e.target.value)}
                    value={deliveryId}
                  >
                    <option value="">select Delivery partner</option>
                    {DeliveryList &&
                      DeliveryList?.map((res, i) => (
                        <option key={i} value={res?.id}>
                          {res?.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-12 mb-3">
                  <label>Expected Delivery Days</label>
                  <div className="row">
                    <div className="col-5">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Min. Day"
                        value={Min_delivery_day}
                        onChange={(e) => {
                          setMin_delivery_day(e?.target?.value);
                        }}
                      />
                      {error && !Min_delivery_day && (
                        <div className="error mt-1">Min Days is required</div>
                      )}
                    </div>
                    <div className="col-5">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Max. Day"
                        value={Max_delivery_day}
                        onChange={(e) => {
                          setMax_delivery_day(e?.target?.value);
                        }}
                      />
                      {error && !Max_delivery_day && (
                        <div className="error mt-1">Max Days is required</div>
                      )}
                    </div>
                    <span className="text-small">Days</span>
                  </div>
                </div>
              </>
            )}

            {orderstatus?.status === "Cancel Order" && (
              <div className="col-12 mb-3">
                <label>cancellation Reason</label>
                <textarea
                  placeholder="Write Reason"
                  className="form-control"
                  value={orderMessage}
                  onChange={(e) => setorderMessage(e?.target?.value)}
                ></textarea>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-secondary py-2"
            onClick={() => setmodalShow(false)}
          >
            Close
          </Button>
          <Button
            className="btn btn-primary py-2"
            onClick={() => changeStatus(orderstatus, orderstatus?.status)}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
